export function validateRefInsightCredentials(creds: string): boolean {
    return /^.+&.+$/.test(creds);
}
